/**
 * turns a query object to a string to be appended to an http request url
 * @param {object} options - the parameters to be sent with a http request url
 */
function encodeQ(options) {
  if (options) {
    const s = objectToQueryString(options);
    return s.length > 0 ? `?${s}` : '';
  }
  return '';
}

// https://gist.github.com/dgs700/4677933
// modified later to use URLSearchParams
/**
 * turns an object into a string that can be used in a http request url
 * @param {object} a - the object to be turned into a query string
 */
function objectToQueryString(a) {
  const s = new URLSearchParams();
  const add = (key, value) => {
    // If value is a function, invoke it and return its value
    const v = typeof value === 'function' ? value() : value == null ? '' : value;
    s.append(key, v);
  };
  if (a instanceof Array) {
    for (let n = 0; n < a.length; n++) {
      add(n, a[n]);
    }
  } else if (a != null) {
    Object.keys(a).forEach(prefix => {
      buildParams(prefix, a[prefix], add);
    });
  }
  const output = s.toString();
  return output;
}

/**
 * manipulates obj according to the add function provided to it   
 * @param {string} prefix
 * @param {object|array} obj - the object to be manipulated
 * @param {function} add - function used to do the manipulation
 */
function buildParams(prefix, obj, add) {
  let i, l;
  const rbracket = /\[\]$/;
  if (obj instanceof Array) {
    for (i = 0, l = obj.length; i < l; i++) {
      if (rbracket.test(prefix)) {
        add(prefix, obj[i]);
      } else {
        buildParams(`${prefix}[${typeof obj[i] === 'object' ? i : ''}]`, obj[i], add);
      }
    }
    // don't forget, null is an object too!
  } else if (typeof obj === 'object' && obj != null) {
    // Serialize object item.
    Object.keys(obj).forEach(name => {
      buildParams(`${prefix}[${name}]`, obj[name], add);
    });
  } else {
    // Serialize scalar item.
    add(prefix, obj);
  }
}

/**
 * transforms an object into an array of {path, value, op} objects
 * @param {object} patchOps 
 */

function getPatchOpsArray(patchOps) {
  let arr = patchOps;
  if (arr && !Array.isArray(arr)) {
    // assume replace of each key
    arr = [];
    Object.keys(patchOps).forEach(key => {
      if (patchOps[key] == null) {
        arr.push({
          op: 'remove',
          path: key
        });
      } else {
        arr.push({
          op: 'replace',
          path: key,
          value: patchOps[key]
        });
      }
    });
  }
  return arr;
}

/**
 * checks for '/' and appends the subpath onto the path
 * @param {string} path 
 * @param {string} subpath 
 */
function combinePath(path, subpath) {
  let p = path;
  if (subpath) {
    const needsSlash = path !== '' && !path.endsWith('/') && subpath[0] !== '/';
    if (needsSlash) {
      p += '/';
    }
    p += subpath;
  }
  return p;
}

/**
 * returns id if id is string or id.id if id is an object
 * @param {string|object} id 
 * @param {boolean?} throwIfNull - if true will throw an error if there is no id
 */
function getId(id, throwIfNull = true) {
  const oid = id;
  id = id != null && typeof id === 'object' ? id.id : id;
  if (id == null && throwIfNull) {
    console.log('error', oid);
    /* eslint-disable */
    throw {
      status: 400,
      message: 'id is null'
    };
    /* eslint-enable */
  }
  return id;
}

/**
 * returns the substring after the last '/'
 * @param {string} path 
 */
function getLastInPath(path) {
  if (path == null) {
    return null;
  }
  const idx = path.lastIndexOf('/');
  if (idx < 0) {
    return null;
  }
  return path.substring(idx + 1);
}
function filterObjectFunctionProps(obj) {
  const ret = {};
  Object.keys(obj).forEach(key => {
    const item = obj[key];
    if (typeof item === 'function') {
      return;
    }
    if (Array.isArray(item)) {
      ret[key] = filterArrayFunctionMembers(item);
      return;
    }
    if (item != null && typeof item === 'object') {
      ret[key] = filterObjectFunctionProps(item);
      return;
    }
    ret[key] = item;
  });
  return ret;
}
function filterArrayFunctionMembers(arr) {
  return arr.reduce((prev, member) => {
    if (typeof member === 'function') {
      return prev;
    }
    if (member == null) {
      prev.push(member);
      return prev;
    }
    if (Array.isArray(member)) {
      prev.push(filterArrayFunctionMembers(member));
      return prev;
    }
    if (typeof member === 'object') {
      prev.push(filterObjectFunctionProps(member));
      return prev;
    }
    prev.push(member);
    return prev;
  }, []);
}
export default {
  encodeQ,
  getPatchOpsArray,
  combinePath,
  getId,
  getLastInPath,
  filterObjectFunctionProps,
  filterArrayFunctionMembers
};